/*!
 * Lekonas Footer Pro
 * assets/lekonas-footer-pro.js
 */

(() => {
  "use strict";

  const SELECTOR = "[data-footer-pro]";

  document.querySelectorAll(SELECTOR).forEach((footer) => {
    initAccordion(footer);
    initBackToTop(footer);
    initNewsletterUX(footer);
  });

  function initAccordion(footer) {
    if (!footer.classList.contains("lekonas-footer-pro--mobile-accordion-true")) return;

    const media = window.matchMedia("(max-width: 749px)");

    const setup = () => {
      const items = footer.querySelectorAll(".lekonas-footer-pro__menu-column");

      items.forEach((item, index) => {
        const button = item.querySelector(".lekonas-footer-pro__menu-toggle");
        if (!button) return;

        if (!button.dataset.bound) {
          button.dataset.bound = "true";

          button.addEventListener("click", () => {
            if (!media.matches) return;

            const open = item.classList.contains("is-open");

            items.forEach((i) => {
              i.classList.remove("is-open");
              const b = i.querySelector(".lekonas-footer-pro__menu-toggle");
              if (b) b.setAttribute("aria-expanded", "false");
            });

            if (!open) {
              item.classList.add("is-open");
              button.setAttribute("aria-expanded", "true");
            }
          });
        }

        if (index === 0 && media.matches) {
          item.classList.add("is-open");
          button.setAttribute("aria-expanded", "true");
        }
      });
    };

    setup();
    media.addEventListener("change", () => {
      footer.querySelectorAll(".lekonas-footer-pro__menu-column").forEach((i) => {
        i.classList.remove("is-open");
        const b = i.querySelector(".lekonas-footer-pro__menu-toggle");
        if (b) b.setAttribute("aria-expanded", "false");
      });
      setup();
    });
  }

  function initBackToTop(footer) {
    const button = footer.querySelector(".lekonas-footer-pro__back-to-top");
    if (!button) return;

    const toggle = () => {
      button.style.opacity = window.scrollY > 500 ? "1" : "0";
      button.style.pointerEvents = window.scrollY > 500 ? "auto" : "none";
    };

    toggle();
    window.addEventListener("scroll", toggle, { passive: true });

    button.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }

  function initNewsletterUX(footer) {
    const input = footer.querySelector('input[type="email"]');
    if (!input) return;

    input.addEventListener("input", () => {
      input.classList.remove("is-invalid");
    });

    const form = input.closest("form");
    if (!form) return;

    form.addEventListener("submit", () => {
      if (!input.value.trim()) {
        input.classList.add("is-invalid");
      }
    });
  }
})();
